import styles from '../../styles/components/items/Buttonprimary.module.css'

export default function Button_primary({label,type}) {
  return (
    <button type={type} className={styles.btn_primary}>
      {label}
    </button>
  )
}
